import { IUpdateControlePatrimonioControleUseCase } from "../../../presentation/useCases/update/update_controle_patrimonio_controle_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * UpdateControlePatrimonioControleUseCase
 */

export class UpdateControlePatrimonioControleUseCase implements IUpdateControlePatrimonioControleUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async updateControlePatrimonioControle(
    idControleCentroCusto: number,
    idCentroCusto: number,
  ): Promise<void> {
    await this.repository.updateControlePatrimonioControle(
      idControleCentroCusto,
      idCentroCusto,
    );
  }
}
